<template>
  <div class="profileupdate">
    <div class="col">
      <div class="row align-item-center pt-2 pb-2">
        <div class="col">
          <h2 class="ui text huge-lg big-sm large black mb-0">{{$t('Update')}}</h2>
        </div>
      </div>
      <hr class="gray-7 mt-0">
      <form>
        <div class="ui form">
          <div class="row mt-2 mb-2 align-items-center">
            <div class="col-12 col-lg-3 text-lg-right">
              <label class="ui text medium-sm small">{{$t('Name')}}</label>
            </div>
            <div class="col-12 col-lg-3">
              <input
                v-model="updateUser.firstname"
                class="ui input text medium-sm small"
                type="text"
                placeholder
              >
            </div>
            <div class="col-12 col-lg-3">
              <input
                v-model="updateUser.lastname"
                class="ui input text medium-sm small"
                type="text"
                placeholder
              >
            </div>
          </div>
          <div class="row mt-2 mb-2 align-items-center">
            <div class="col-12 col-lg-3 text-lg-right">
              <label class="ui text medium-sm small">{{$t('Sex')}}</label>
            </div>
            <div class="col-12 col-lg-6">
              <select
                v-model="updateUser.gender"
                class="ui input text medium-sm small search custom-select col-12"
              >
                <option
                  v-for="gender in genders"
                  :selected="gender == 'female'"
                  :value="gender.name"
                >{{gender.name}}</option>
              </select>
            </div>
          </div>
          <div class="row mt-2 mb-2 align-items-center">
            <div class="col-12 col-lg-3 text-lg-right">
              <label class="ui text medium-sm small">{{$t('Birthday')}}</label>
            </div>
            <div class="col-12 col-lg-6">
              <input
                v-model="updateUser.birthdate"
                class="ui input text medium-sm small"
                type="date"
                placeholder
              >
            </div>
          </div>
          <div class="row mt-2 mb-2 align-items-center">
            <div class="col-12 col-lg-3 text-lg-right">
              <label class="ui text medium-sm small">{{$t('Mobile')}}</label>
            </div>
            <div class="col-12 col-lg-6">
              <input
                v-model="updateUser.phone"
                class="ui input text medium-sm small"
                type="text"
                placeholder
              >
            </div>
          </div>
          <div class="row mt-2 mb-2 align-items-center">
            <div class="col-12 col-lg-3 text-lg-right">
              <label class="ui text medium-sm small">{{$t('Email')}}</label>
            </div>
            <div class="col-12 col-lg-6">
              <input
                v-model="updateUser.email"
                class="ui input text medium-sm small"
                type="text"
                placeholder
              >
            </div>
          </div>
          <div class="row mt-2 mb-2 align-items-center">
            <div class="col-12 col-lg-3 text-lg-right">
              <label class="ui text medium-sm small"></label>
            </div>
            <div class="col-12 col-lg-6">
              <div class="row">
                <div class="col">
                  <a
                    @click="updateProfile"
                    class="ui button theme text medium shadow w-100 py-2 px-2"
                  >{{$t('Save')}}</a>
                </div>
                <div class="col">
                  <router-link
                    :to="'/profile'"
                    exact
                    class="ui button grey text medium shadow w-100 py-2 px-2"
                  >{{$t('Cancel')}}</router-link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
export default {
  name: "profileupdate",
  components: {},
  props: {
    user: {
      type: Object,
      default: {}
    }
  },
  data() {
    return {
      genders: [{ name: "male" }, { name: "female" }],
      message: {
        title: "แก้ไขข้อมูลส่วนตัว",
        message: ""
      },
      updateUser: {}
    };
  },
  created() {
    this.getUser();
    this.$parent.$parent.message.title = "แก้ไขข้อมูลส่วนตัว";
  },
  watch: {
    user() {
      this.getUser();
    }
  },
  methods: {
    getUser() {
      let user = {
        birthdate: this.user.birthdate,
        email: this.user.email,
        firstname: this.user.firstname,
        gender: this.user.gender,
        lastname: this.user.lastname,
        phone: this.user.phone
      };
      if (user.birthdate != undefined) {
        user.birthdate = this.getFormattedDate(user.birthdate);
      }
      this.updateUser = user;
    },
    getFormattedDate(date) {
      let dateSplit = date.split("/");
      return dateSplit[2] + "-" + dateSplit[1] + "-" + dateSplit[0];
    },
    updateProfile() {
      let data = this.updateUser;
      if (data.gender == null || data.gender == "") {
        delete data.gender;
      }
      if (data.birthdate == null || data.birthdate == "") {
        delete data.birthdate;
      }
      if (data.firstname == null || data.firstname == "") {
        delete data.firstname;
      }
      if (data.lastname == null || data.lastname == "") {
        delete data.lastname;
      }
      if (data.phone == null || data.phone == "") {
        delete data.phone;
      }
      if (data.email == null || data.email == "") {
        delete data.email;
      }

      // return
      this.$http
        .put("profile", data)
        .then(response => {
          this.$parent._getProfile();
          this.$router.push("/profile");
        })
        .catch(error => {
          if (!error.response) {
            return;
          }
          let message = error.response.data.errors
            ? error.response.data.errors.message
            : error.response.data.message;
          switch (message) {
            case "the_email_field_is_required.":
              message = "กรุณากรอกอีเมล";
              break;
            case "the_email_field_is_required.":
              message = "กรุณากรอกอีเมล";
              break;
            case "the_password_field_is_required.":
              message = "กรุณากรอกรหัสผ่าน";
              break;
            case "the_password_must_be_at_least4_characters.":
              message = "รหัสผ่านอย่างน้อย 4 ตัว";
              break;
            case "the_email_has_already_been_taken.":
              message = "มีผู้ใช้งานนี้อีเมลแล้ว";
              break;
          }
          this.$parent.$parent.message.message = message;
          this.$parent.$parent.showMessage = !this.$parent.$parent.showMessage;
        })
        .finally(() => (this.loading = false));
    }
  }
};
</script>
